import "./aprovadorEng.css";
import { useState, useEffect } from "react";
import { AppDispatch, RootState } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import usePersistedState from "../../../hooks/usePersistedState";
import {
  getUserEngDelete,
  getUserEngInternals,
  getPutEditCreaEng,
  getPutUserEngInternals
} from "../../../redux/actions/fluxoNSimilar";
import { SkeletonWrapper } from "../../../componentes/SkeletonWrapper/sleketonWrapper";
import { Tooltip } from "@mui/material";
import HeadingAprovador from "../../fluxo-engenheiro/heading/headingAprovador";
import GenericGrid from "../../fluxo-engenheiro/grid/grid";
import { useRoles } from "../../../hooks/roles";
import Delete from "../../../assets/img/excluir.png";
import SucessIcon from "../../../assets/svgs/sucess.svg";
import ModalAprover from "../../fluxo-tax/modalAprover/modalAprover";
import functionDate from "../../../utils/formatarData";
import Textnotifications from "../../../utils/notifications";
import { EditModal } from "../../EditUserComponent/EditModal";
import Notification from "../../../componentes/fluxo-tax/Notification/notification";
import { DadosAprovador } from "../DadosAprovador/DadosAprovador";
import { GenericModal } from "../../ModalGeneric/ModalGeneric";
import { EditFormData } from "../../fluxo-tax/smallModalEdit/smallModalEdit";
import { getUser } from "../../../redux/actions/user";
import { usePaginationState } from "../../../hooks/usePaginationState";
import { useModalState } from "../../../hooks/useModalState";
import { useNotification } from "../../../hooks/useNotification";
import { handleDeleteGeneric } from "../../../hooks/useDeleteHandler";
import { buildAprovadorColumns } from "../../../utils/DataGrid/aprovadorColumns";
import { usePersistedPagination } from "../../../hooks/usePersistedPagination";

export interface EditCreaData {
  email: string;
  crea: string;
}

export interface PutUserEngInternals {
  engineersToBecomeAssociates: string[];
}

const AprovadorEng = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { isEngineer } = useRoles();
  const { basicUserInfo } = useSelector((state: any) => state.user);
  const { sessionUsersEng } = useSelector(
    (state: RootState) => state.sessionClassifications,
  );

  const paginationState = usePaginationState();
  const persistedPagination = usePersistedPagination("pagination_aprovador_eng");
  const pagination = { ...paginationState, ...persistedPagination };
  const deleteModal = useModalState();
  const editModal = useModalState();
  const creaModal = useModalState();
  const {
    notification,
    labelNotification,
    backgroundColor,
    setNotification,
    showNotification,
  } = useNotification();

  const [email, setEmail] = usePersistedState("email", "");
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [selectedUser] = useState<EditFormData | null>(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [creaValue, setCreaValue] = useState(basicUserInfo.crea);

  useEffect(() => {
    dispatch(getUserEngInternals({ page: pagination.page }));
  }, [pagination.page]);

  useEffect(() => {
    if (!isEngineer || !sessionUsersEng) return;
    pagination.setRows(sessionUsersEng.content ?? []);
    pagination.setTotalPages(sessionUsersEng.page?.totalPages ?? 0);
  }, [isEngineer, sessionUsersEng]);

  const handleDelete = async () => {
    await handleDeleteGeneric({
      dispatch,
      deleteAction: (id) => getUserEngDelete({ id }),
      refreshAction: getUserEngInternals,
      page: pagination.page,
      selectedValue: selectedId,
      onSuccess: () => showNotification("Aprovador deletado com sucesso."),
      onFinally: deleteModal.close,
    });
  };

  const handleConfirm = async (data: any) => {
    try {
      const payload: PutUserEngInternals = {
        engineersToBecomeAssociates: data.engineersToBecomeAssociates,
      };

      await dispatch(getPutUserEngInternals(payload)).unwrap();
      showNotification("Usuários associados com sucesso.");
      await dispatch(getUserEngInternals({ page: pagination.page }));
      editModal.close();
    } catch (error) {
      console.error("Erro ao confirmar:", error);
    }
  };

  const handleEditCrea = async (data: EditCreaData) => {
    try {
      await dispatch(getPutEditCreaEng(data)).unwrap();
      showNotification("CREA editado com sucesso.");
      await dispatch(getUser());
      creaModal.close();
    } catch (error) {
      console.error("Erro ao editar CREA:", error);
    }
  };

  const handleFilter = async () => {
    pagination.setLoading(true);
    await dispatch(getUserEngInternals({ email: email.toString() })).finally(
      () => pagination.setLoading(false),
    );
  };

  
  const columns = buildAprovadorColumns({
    idField: "id",
    showActions: true,
    renderActions: (row) => (
      <Tooltip title="Excluir">
        <button
          className="btn-delete"
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            setSelectedId(row.id);
            deleteModal.open();
          }}
        >
          <img src={Delete} alt="Excluir" style={{ width: 16, height: 20 }} />
        </button>
      </Tooltip>
    ),
  });


  return (
    <div style={{ height: "100%" }}>
      <SkeletonWrapper loading={pagination.loading} />

      {!pagination.loading && (
        <>
          <div className="containerHomePage">
            <HeadingAprovador
              titlePage="Associar usuários"
              titleButton="Cadastrar Associado"
              filtros="sim"
              blockText="sim"
              emitentePartNumber={email}
              setEmitentePartDesc={setEmail}
              handleFilter={handleFilter}
              onOpen={editModal.open}
            />
          </div>

          <div className="containerRequest">
            <DadosAprovador
              email={basicUserInfo.email}
              crea={basicUserInfo.crea}
              onEditCrea={creaModal.open}
            />
            <GenericGrid
              titleGrid="Usuários associados cadastrados"
              rows={pagination.rows}
              totalPages={pagination.totalPages}
              page={pagination.page}
              columns={columns}
              setCurrentPage={pagination.setPage}
              setLoading={pagination.setLoading}
              setPage={pagination.setPage}
            />
          </div>
        </>
      )}

      {deleteModal.isOpen && (
        <ModalAprover
          titleModal="Excluir Usuário Associado"
          titleDescription={
            <div
              style={{
                marginBottom: 20,
                marginTop: 15,
              }}
              className="titleAprover"
              dangerouslySetInnerHTML={{
                __html: functionDate.formatBodyText(
                  Textnotifications.getDeleteGeneric(
                    "Você deseja excluir esse Usuário Associado?",
                  ),
                ),
              }}
            />
          }
          bodyModal=""
          buttonOne="Confirmar"
          onConfirm={handleDelete}
          buttonTwo="Cancelar"
          onClose={deleteModal.close}
          isSubmitting={false}
        />
      )}

      {editModal.isOpen && (
        <EditModal
          open
          onClose={editModal.close}
          onConfirm={handleConfirm}
          mode="create"
          initialData={selectedUser ?? undefined}
          isSubmitting={false}
          isButtonDisabled={isButtonDisabled}
          onDisableButton={setIsButtonDisabled}
          isAssociated={true}
        />
      )}

      {creaModal.isOpen && (
        <GenericModal
          title="Edição do CREA"
          fields={[
            {
              name: "crea",
              label: "Deseja editar o CREA?",
              placeholder: "Informe o CREA correto",
              value: creaValue,
              onChange: setCreaValue,
            },
          ]}
          primaryButton="Corrigir"
          secondaryButton="Cancelar"
          onConfirm={() =>
            handleEditCrea({ email: basicUserInfo.email, crea: creaValue })
          }
          onClose={creaModal.close}
          isConfirmDisabled={!creaValue}
        />
      )}

      {notification && (
        <Notification
          label={labelNotification}
          backgroundError={backgroundColor}
          setNotification={setNotification}
          img={SucessIcon}
        />
      )}
    </div>
  );
};;

export default AprovadorEng;
